import { __assign } from "tslib";
import React from 'react';
import { DeviationTypes } from '../../../types/deviation';
import { getDeviationType } from '../../_helpers';
import PollThumb from './Poll';
import StatusThumb from './Status';
import DefaultThumb from './Default';
import TierThumb from './Tier';
var StandardThumb = function (props) {
    var type = getDeviationType(props.deviation);
    switch (type) {
        case DeviationTypes.POLL:
            return React.createElement(PollThumb, __assign({}, props));
        case DeviationTypes.STATUS:
            return React.createElement(StatusThumb, __assign({}, props));
        case DeviationTypes.TIER:
            return React.createElement(TierThumb, __assign({}, props));
        default:
            return React.createElement(DefaultThumb, __assign({}, props));
    }
};
StandardThumb.displayName = 'StandardThumb';
export default StandardThumb;
//# sourceMappingURL=Standard.js.map